"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.description.placeholder': 'Introducir descripción del conocimiento',
};
